module.exports = __webpack_public_path__ + "static/media/icon-card.0795ba99.svg";